import React, { createContext, useContext, useMemo } from 'react'

import { SearchParams } from 'src/api/types'
import { useDidMount } from 'src/hooks'
import { useSafeReducer } from 'src/hooks/use-safe-reducer'
import { useActions } from './actions'
import { getInitialState } from './initialState'
import { reducer } from './reducer'
import { Context } from './types'
import { useGlobalState } from '../global'

export const ResultContext = createContext<Context | null>(null)

export const ResultContextProvider: React.FC<{
  initialParams: Record<keyof SearchParams, string | string[]>
  children: React.ReactNode
}> = ({ children, initialParams }) => {
  const initialState = getInitialState(initialParams)

  const [globalState] = useGlobalState()
  const [state, dispatch] = useSafeReducer(reducer, initialState)
  const actions = useActions(dispatch, state)

  const value: Context = useMemo(() => [state, actions], [state, actions])

  useDidMount(() => {
    if (!globalState.isLoading) {
      actions?.search({
        search: initialState.search,
        filter: initialState.filter,
        shouldReplaceSearch: false,
      })
    }
  }, [globalState.isLoading])

  return (
    <ResultContext.Provider value={value}>{children}</ResultContext.Provider>
  )
}

export const useResultsState = () => useContext(ResultContext) as Context
